import styled from 'styled-components';
import {
    BoldTextColor,
    BrighterGreen,
    PrimaryTextColor,
    TextColor,
} from '../../../app/theme/tokens/colors';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${PrimaryTextColor};
  line-height: 1.35;
`;

export const UploadGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 15px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const DropZone = styled.label`
  display: block;
  border: 2px dashed ${TextColor};
  border-radius: 10px;
  padding: 16px;
  background: #fafafa;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;

  &:hover {
    border-color: ${BrighterGreen};
    background: #f6fff0;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const DropZoneInner = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const DropIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #ededed;
  flex-shrink: 0;
`;

export const DropText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const DropTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${BoldTextColor};
`;

export const DropHint = styled.div`
  font-size: 12px;
  color: ${PrimaryTextColor};
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ededed;
  flex-wrap: wrap;
`;

export const FilePill = styled.div`
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid #ededed;
  background: #fff;
  max-width: 100%;
`;

export const FileName = styled.div`
  font-size: 12px;
  color: ${BoldTextColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 360px;

  @media (max-width: 900px) {
    max-width: 220px;
  }
`;

export const FileSize = styled.div`
  font-size: 12px;
  color: ${PrimaryTextColor};
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 13px;
  color: ${BoldTextColor};
  margin-bottom: 8px;
`;

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
`;

export const HelperText = styled.div`
  font-size: 12px;
  color: ${PrimaryTextColor};
  line-height: 1.4;
`;

export const ModalList = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: ${PrimaryTextColor};
  font-size: 12px;
  line-height: 1.5;

  li {
    margin: 6px 0;
  }
`;

export const PreCheckBox = styled.div`
  border: 1px solid #ededed;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
`;

export const PreCheckError = styled.div`
  font-size: 12px;
  color: #b42318;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.45;
`;

export const PreviewTableWrap = styled.div`
  width: 100%;
  overflow: auto;
`;

export const PreviewTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  min-width: 520px;

  th,
  td {
    border-bottom: 1px solid #ededed;
    padding: 8px 10px;
    font-size: 12px;
    text-align: left;
    vertical-align: top;
  }

  th {
    position: sticky;
    top: 0;
    background: #ffffff;
    color: ${BoldTextColor};
    font-weight: 700;
    z-index: 1;
    border-bottom: 1px solid #e0e0e0;
  }

  td {
    color: ${PrimaryTextColor};
    max-width: 380px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const EmptyPreview = styled.div`
  padding: 12px;
  font-size: 12px;
  color: ${PrimaryTextColor};
`;

export const HistoryWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const HistoryItem = styled.div`
  border: 1px solid #ededed;
  border-radius: 10px;
  padding: 10px 12px;
  background: ${(p) => (p.$highlight ? '#f6fff0' : '#fff')};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

export const HistoryMain = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HistoryFile = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${BoldTextColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
`;

export const HistoryDate = styled.div`
  font-size: 12px;
  color: ${PrimaryTextColor};
`;

export const HistoryBadge = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: ${BrighterGreen};
  border: 1px solid #d5f0c3;
  background: #ffffff;
  padding: 5px 8px;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const PreviewMeta = styled.div`
  padding: 10px 12px;
  font-size: 12px;
  color: ${PrimaryTextColor};
  border-bottom: 1px solid #ededed;
  background: #fafafa;
`;

export const formatBytes = (bytes) => {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} KB`;
    const mb = kb / 1024;
    return `${mb.toFixed(1)} MB`;
};
